<template>
  <div style="display:flex;flex-direction:column;height:100vh;">
    <app-header></app-header>
    <app-main class="main"></app-main>
  </div>
</template>

<script>
import AppHeader from './AppHeader/index_GLYF.vue';
import AppMain from './AppMain/index_GLYF_admin.vue';

export default {
    components: {
        AppHeader,
        AppMain
    }
}
</script>

<style scoped>
.main {
  flex: 1; 
  display: flex;
  min-height: 0;
  /* position: absolute; */
  background-color: #fff;
  /* left: 0px;
  right: 0px;
  bottom: 0px;
  top: 70px; */
  /* padding: 30px; */
  /* overflow-y: auto; */
  color: #000;
  /* min-width: 1370px; */
  min-width: 0;
}
</style>